const COLORS = ['#FF7A1A', '#FFD24D', '#FFAB5E', '#34d399', '#60a5fa', '#f472b6'];

export function Confetti() {
  const pieces = Array.from({ length: 24 }, (_, i) => ({
    left: `${(i * 37) % 100}%`,
    delay: `${(i % 6) * 0.08}s`,
    color: COLORS[i % COLORS.length],
    size: 6 + (i % 3) * 3,
  }));
  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 h-64 overflow-hidden" aria-hidden="true">
      {pieces.map((p, i) => (
        <span
          key={i}
          className="absolute top-0 block rounded-sm animate-confetti"
          style={{ left: p.left, animationDelay: p.delay, backgroundColor: p.color, width: p.size, height: p.size * 1.6 }}
        />
      ))}
    </div>
  );
}
